import React, { useEffect, useMemo, useRef, useState } from 'react';
import './Sidebar.css';
import { NavLink, useLocation } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import PolicyIcon from '@mui/icons-material/Policy';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import SearchIcon from '@mui/icons-material/Search';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PercentIcon from '@mui/icons-material/Percent';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import RateReviewIcon from '@mui/icons-material/RateReview';
import RuleIcon from '@mui/icons-material/Rule';
import AddBoxIcon from '@mui/icons-material/AddBox';
import KeyboardCapslockIcon from '@mui/icons-material/KeyboardCapslock';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import RedeemIcon from '@mui/icons-material/Redeem';
import BlockIcon from '@mui/icons-material/Block';
import StarIcon from '@mui/icons-material/Star';
import TuneIcon from '@mui/icons-material/Tune';
import InventoryIcon from '@mui/icons-material/Inventory';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CodeIcon from '@mui/icons-material/Code';
import GarageIcon from '@mui/icons-material/Garage';
import SummarizeIcon from '@mui/icons-material/Summarize';
import EuroIcon from '@mui/icons-material/Euro';
import MinorCrashIcon from '@mui/icons-material/MinorCrash';
import PreviewIcon from '@mui/icons-material/Preview';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import BrowserNotSupportedIcon from '@mui/icons-material/BrowserNotSupported';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import RouteIcon from '@mui/icons-material/Route';
import StorageIcon from '@mui/icons-material/Storage';
import AirlineSeatLegroomReducedIcon from '@mui/icons-material/AirlineSeatLegroomReduced';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import CameraIcon from '@mui/icons-material/Camera';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { baseURL } from '../pages/backend_url';
import axios from 'axios';
import PublishIcon from '@mui/icons-material/Publish';
import ComputerIcon from '@mui/icons-material/Computer';
import CommuteIcon from '@mui/icons-material/Commute';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ReservationInsights from "@mui/icons-material/RequestQuote";
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import BoltIcon from '@mui/icons-material/Bolt';
import ReviewsIcon from '@mui/icons-material/Reviews';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import {
  getMenuSection,
  getModuleRoute,
  menuSectionDefinitions,
  normalizeNavigationPath,
} from './navigationMetadata';


const iconHash = {
    "Dashboard": <DashboardIcon />,
    "Account": <BusinessIcon />,
    "Account Locations": <AddLocationAltIcon />,
    "User": <GroupIcon />,
    "Location": <EditLocationAltIcon />,
    "Business Hours": <WorkHistoryIcon />,
    "Policies": <PolicyIcon />,
    "Tax": <PercentIcon />,
    "Optional Services": <AddBoxIcon />,
    "Fleet Description": <DirectionsCarIcon />,
    "One Way Rental": <AddRoadIcon />,
    "Reservation Source": <EventSeatIcon />,
    "Rate Code": <CurrencyExchangeIcon />,
    "Account Rate Code": <RateReviewIcon />,
    "Account Rate Rules": <RuleIcon />,
    "Minimum Rate": <KeyboardCapslockIcon />,
    "Rate Update": <PriceChangeIcon />,
    "Adjustment": <EqualizerIcon />,
    "Promotion": <RedeemIcon />,
    "Blackout": <BlockIcon />,
    "Update Inventory": <InventoryIcon />,
    "Utilization Based Adjustment": <TuneIcon />,
    "Error Codes": <CodeIcon />,
    "Access Setup": <ManageAccountsIcon />,
    "Cars": <GarageIcon />,
    "Reports": <SummarizeIcon />,
    "Europcars": <EuroIcon />,
    "Capacity Control": <MinorCrashIcon />,
    "Reservations": <BookOnlineIcon />,
    "No Show": <BrowserNotSupportedIcon />,
    "Fetch Console": <VideogameAssetIcon />,
    "Rate ID": <RouteIcon />,
    "Event Log": <StorageIcon />,
    "Optional Services Standard": <AirlineSeatLegroomReducedIcon />,
    "Fleet Standard": <NoCrashIcon />,
    "Rate Snapshot": <PreviewIcon />,
    "Optional Services Images": <CameraIcon />,
    "Affiliate OTA Mapping" : <AccountTreeIcon />,
    "Bank Reconciliation Report": <AccountBalanceIcon />,
    "Commission Screen": <PublishIcon />,
    "Competitor Setup": <CommuteIcon />,
    "Minimum Rate Mapping": <PriceCheckIcon />,
    "Enable Automation": <ChecklistIcon />,
    "Automation Scheduler": <ComputerIcon />,
    "Currency Converter": <CurrencyExchangeIcon />,
    "Support Screen" : <ContactSupportIcon />,
    "View Base Rates": <RequestQuoteIcon />,
    "Reservation Insights": <ReservationInsights />,
    "Ceiling Rate": <RouteIcon />,
    "Policy Expedia": <RuleFolderIcon />,
    "DBR CleanUp": <CleaningServicesIcon />,
    "Competitors": <MultilineChartIcon />,
    "Instant Automation Pro": <BoltIcon />,
    "Review Screen": <ReviewsIcon />,
    "Automation Report": <FileCopyIcon />,
    "Partner Report": <SummarizeIcon />,
  "MarkUp Info": <LocalOfferIcon />,
};

const NAVIGATION_FAVOURITES_STORAGE_KEY = 'mvp_navigation_favourites_v1';
const NAVIGATION_RECENTS_STORAGE_KEY = 'mvp_navigation_recents_v1';
const MAX_RECENT_MODULES = 6;

const getNavigationStorageScope = () => {
  try {
    const foundUser = JSON.parse(sessionStorage.getItem('user_token'));
    return foundUser?.userID || foundUser?.userEmail || foundUser?.account_id || 'current-user';
  } catch (error) {
    return 'current-user';
  }
};

const readStoredList = (storageKey) => {
  try {
    const storedValue = JSON.parse(localStorage.getItem(storageKey));
    return Array.isArray(storedValue)
      ? storedValue.filter((value) => typeof value === 'string')
      : [];
  } catch (error) {
    return [];
  }
};

const writeStoredList = (storageKey, values) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(values));
  } catch (error) {
    // Navigation remains usable when browser storage is unavailable or full.
  }
};

export default function Sidebar({ collapsed, setCollapsedFlag, sidebarColor, drawerNavigation = false }) {
  const location = useLocation();
  const searchInputRef = useRef(null);
  const navigationStorageScope = useRef(getNavigationStorageScope());
  const favouritesStorageKey = `${NAVIGATION_FAVOURITES_STORAGE_KEY}:${navigationStorageScope.current}`;
  const recentsStorageKey = `${NAVIGATION_RECENTS_STORAGE_KEY}:${navigationStorageScope.current}`;
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState('all');
  const [collapsedSections, setCollapsedSections] = useState({});
  const [menuItemsFinal, setMenuItemsFinal] = useState([]);
  const [favouriteModuleNames, setFavouriteModuleNames] = useState(
    () => readStoredList(favouritesStorageKey)
  );
  const [recentModuleRoutes, setRecentModuleRoutes] = useState(
    () => readStoredList(recentsStorageKey)
  );

  useEffect(() => {
    axios.get(baseURL + "/get_modules")
      .then((res) => {
        const moduleRecords = Array.isArray(res.data) ? res.data : [];
        const menuItems = moduleRecords
          .filter((val1) => {
            const moduleName = typeof val1?.name === 'string'
              ? val1.name.replace(/\s+/g, '')
              : '';
            return moduleName && moduleName !== 'MultipleAccountsAdjustment&Promotion';
          })
          .map((val1) => ({
            "name": val1.name,
            "icon": iconHash[val1.name],
            "routing": getModuleRoute(val1.name),
          }));
        let foundUser = null;

        try {
          const loggedInUser = sessionStorage.getItem("user_token");
          foundUser = loggedInUser ? JSON.parse(loggedInUser) : null;
        } catch (error) {
          foundUser = null;
        }

        if (!foundUser) {
          setMenuItemsFinal([]);
          return;
        }

        const roleDefinition = foundUser.access;

        if (!roleDefinition || typeof roleDefinition !== 'object') {
          setMenuItemsFinal([]);
          return;
        }

        if (foundUser.role_capabilities?.all_modules_access === true) {
          setMenuItemsFinal(menuItems);
          return;
        }

        const canAccess = (moduleName) => {
          const accessSpecifier = roleDefinition[`${moduleName}_Access Specifier`];
          return accessSpecifier === 'Edit' || accessSpecifier === 'View';
        };
        const tempMenuItems = menuItems.filter((val) => {
          const tempModuleName = val.name.toString().trim().replace(/\s+/g, '');

          return tempModuleName === 'SupportScreen'
            || (tempModuleName === 'ViewBaseRates' && canAccess('RateUpdate'))
            || canAccess(tempModuleName);
        });

        setMenuItemsFinal(tempMenuItems);
      })
      .catch(() => {
        setMenuItemsFinal([]);
      });
  }, []);

  useEffect(() => {
    const currentItem = menuItemsFinal.find(
      (item) => normalizeNavigationPath(item.routing) === normalizeNavigationPath(location.pathname)
    );

    if (!currentItem) {
      return;
    }

    setRecentModuleRoutes((currentRoutes) => {
      const nextRoutes = [
        currentItem.routing,
        ...currentRoutes.filter(
          (route) => normalizeNavigationPath(route) !== normalizeNavigationPath(currentItem.routing)
        ),
      ].slice(0, MAX_RECENT_MODULES);

      if (nextRoutes.join('|') === currentRoutes.join('|')) {
        return currentRoutes;
      }

      writeStoredList(recentsStorageKey, nextRoutes);
      return nextRoutes;
    });

    const currentSection = getMenuSection(currentItem.name);
    setCollapsedSections((currentSections) => {
      if (!currentSections[currentSection]) {
        return currentSections;
      }

      return {
        ...currentSections,
        [currentSection]: false,
      };
    });
  }, [location.pathname, menuItemsFinal, recentsStorageKey]);

  useEffect(() => {
    const handleSearchShortcut = (event) => {
      const eventTarget = event.target;
      const isEditableTarget = eventTarget instanceof HTMLElement && (
        eventTarget.isContentEditable
        || ['INPUT', 'TEXTAREA', 'SELECT'].includes(eventTarget.tagName)
      );
      const isSearchShortcut = !isEditableTarget && (
        (
          event.key === '/' && !event.ctrlKey && !event.metaKey && !event.altKey
        ) || (
          event.key.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey)
        )
      );

      if (isSearchShortcut) {
        event.preventDefault();
        if (collapsed) {
          setCollapsedFlag(false);
        }
        window.setTimeout(() => searchInputRef.current?.focus(), 0);
      }

      if (event.key === 'Escape' && document.activeElement === searchInputRef.current) {
        setSearch('');
        searchInputRef.current.blur();
      }
    };

    window.addEventListener('keydown', handleSearchShortcut);
    return () => window.removeEventListener('keydown', handleSearchShortcut);
  }, [collapsed, setCollapsedFlag]);

  const normalizedSearch = search.trim().toLowerCase();
  const searchedMenuItems = useMemo(() => {
    if (!normalizedSearch) {
      return menuItemsFinal;
    }

    return menuItemsFinal.filter((item) => (
      `${item.name} ${getMenuSection(item.name)}`.toLowerCase().includes(normalizedSearch)
    ));
  }, [menuItemsFinal, normalizedSearch]);

  const recentMenuItems = useMemo(() => (
    recentModuleRoutes
      .map((route) => menuItemsFinal.find(
        (item) => normalizeNavigationPath(item.routing) === normalizeNavigationPath(route)
      ))
      .filter(Boolean)
  ), [menuItemsFinal, recentModuleRoutes]);

  const searchedModuleNames = new Set(searchedMenuItems.map((item) => item.name));
  const visibleMenuItems = activeFilter === 'favourites'
    ? searchedMenuItems.filter((item) => favouriteModuleNames.includes(item.name))
    : activeFilter === 'recent'
      ? recentMenuItems.filter((item) => searchedModuleNames.has(item.name))
      : searchedMenuItems;

  const menuSectionLabels = [
    ...menuSectionDefinitions.map((section) => section.label),
    'Other Tools',
  ];

  const groupedMenuItems = activeFilter === 'recent'
    ? [{ label: 'Recent pages', items: visibleMenuItems }].filter((section) => section.items.length > 0)
    : menuSectionLabels
      .map((label) => ({
        label,
        items: visibleMenuItems.filter((item) => getMenuSection(item.name) === label),
      }))
      .filter((section) => section.items.length > 0);

  const changeFavourite = (item) => {
    setFavouriteModuleNames((currentNames) => {
      const nextNames = currentNames.includes(item.name)
        ? currentNames.filter((name) => name !== item.name)
        : [...currentNames, item.name];

      writeStoredList(favouritesStorageKey, nextNames);
      return nextNames;
    });
  };

  const toggleSection = (sectionLabel) => {
    setCollapsedSections((current) => ({
      ...current,
      [sectionLabel]: !current[sectionLabel],
    }));
  };

  const renderMenuItem = (item) => {
    const isFavourite = favouriteModuleNames.includes(item.name);
    const isCurrent = normalizeNavigationPath(item.routing) === normalizeNavigationPath(location.pathname);

    return (
      <li className={`sidebarNavigationItem ${isCurrent ? 'is-current' : ''}`} key={item.name}>
        <NavLink
          to={item.routing}
          end={item.routing === '/'}
          className={({ isActive }) => (isActive ? 'link-active' : 'link')}
          aria-current={isCurrent ? 'page' : undefined}
          title={isCurrent ? `${item.name} (current page)` : `Open ${item.name}`}
          onClick={() => {
            if (drawerNavigation) {
              setCollapsedFlag(true);
            }
          }}
        >
          <span className="sidebarListItem">
            {item.icon}
            {!collapsed && <span>{item.name}</span>}
          </span>
          {!collapsed && isCurrent && <span className="sidebarCurrentDot" aria-hidden="true" />}
        </NavLink>
        {!collapsed && (
          <button
            type="button"
            className={`sidebarFavourite ${isFavourite ? 'is-favourite' : ''}`}
            aria-label={isFavourite ? `Remove ${item.name} from favourites` : `Add ${item.name} to favourites`}
            aria-pressed={isFavourite}
            title={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
            onClick={() => changeFavourite(item)}
          >
            {isFavourite ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
          </button>
        )}
      </li>
    );
  };




  const emptyStateTitle = normalizedSearch
    ? `No matches for "${search.trim()}"`
    : activeFilter === 'favourites'
      ? 'No favourite modules yet'
      : activeFilter === 'recent'
        ? 'No recent pages yet'
        : 'No modules available';
  const emptyStateDescription = normalizedSearch
    ? 'Try a module name or category.'
    : activeFilter === 'favourites'
      ? 'Select a star beside any module to keep it here.'
      : activeFilter === 'recent'
        ? 'Pages you visit will appear here automatically.'
        : 'Your available modules will appear here.';

  return (
    <aside
      id="mvp-primary-navigation"
      className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''}`}
      style={{ backgroundColor: sidebarColor === "" ? "" : sidebarColor }}
      aria-label="Primary navigation"
    >
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
          <div className="sidebarHeading">
            {!collapsed && (
              <div className="sidebarHeadingCopy">
                <span>Workspace</span>
                <small>Vendor operations</small>
              </div>
            )}
            <button
              type="button"
              className="sidebarCollapseButton"
              aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
              title={collapsed ? 'Expand navigation' : 'Collapse navigation'}
              onClick={() => {
                setCollapsedFlag(!collapsed)
              }}
            >
              {collapsed ? (
                <ChevronRightRoundedIcon />
              ) :
                (
                  <KeyboardArrowLeftRoundedIcon />
                )
              }
            </button>
          </div>

          <ul className={`sidebarList ${collapsed ? 'collapsed' : ''}`}>

            <li className="sidebarSearchItem">
              {collapsed ?
                <button
                  type="button"
                  className="sidebarIconButton"
                  title="Search modules (Ctrl+K or /)"
                  aria-label="Search modules"
                  aria-keyshortcuts="/ Control+K Meta+K"
                  onClick={() => {
                    setCollapsedFlag(false);
                    window.setTimeout(() => searchInputRef.current?.focus(), 0);
                  }}
                >
                  <SearchIcon />
                </button>
                : <TextField
                  className="sidebarSearchField"
                  id="sidebar-module-search"
                  label="Search modules"
                  placeholder="Name or category"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={search}
                  inputRef={searchInputRef}
                  onChange={(e) => setSearch(e.target.value)}
                  inputProps={{
                    'aria-keyshortcuts': '/ Control+K Meta+K',
                    autoComplete: 'off',
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="sidebarSearchAdornment" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {search ? (
                          <button
                            type="button"
                            className="sidebarSearchClear"
                            aria-label="Clear module search"
                            title="Clear search"
                            onClick={() => {
                              setSearch('');
                              searchInputRef.current?.focus();
                            }}
                          >
                            <CloseRoundedIcon />
                          </button>
                        ) : (
                          <kbd className="sidebarSearchShortcut" title="Press / to search">/</kbd>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />}
            </li>

            <li className="sidebarFilterItem">
              {collapsed ? (
                <div className="sidebarCollapsedShortcuts" aria-label="Navigation shortcuts">
                  <button
                    type="button"
                    className="sidebarIconButton"
                    title="Show favourites"
                    aria-label="Show favourite modules"
                    onClick={() => {
                      setActiveFilter('favourites');
                      setCollapsedFlag(false);
                    }}
                  >
                    <BookmarksIcon />
                  </button>
                  <button
                    type="button"
                    className="sidebarIconButton"
                    title="Show recent pages"
                    aria-label="Show recent pages"
                    onClick={() => {
                      setActiveFilter('recent');
                      setCollapsedFlag(false);
                    }}
                  >
                    <HistoryRoundedIcon />
                  </button>
                </div>
              ) : (
                <div className="sidebarFilterToggle" role="group" aria-label="Module filter">
                  <button
                    type="button"
                    className={activeFilter === 'all' ? 'is-active' : ''}
                    aria-pressed={activeFilter === 'all'}
                    onClick={() => setActiveFilter('all')}
                  >
                    All
                  </button>
                  <button
                    type="button"
                    className={activeFilter === 'favourites' ? 'is-active' : ''}
                    aria-pressed={activeFilter === 'favourites'}
                    onClick={() => setActiveFilter('favourites')}
                  >
                    Favourites
                  </button>
                  <button
                    type="button"
                    className={activeFilter === 'recent' ? 'is-active' : ''}
                    aria-pressed={activeFilter === 'recent'}
                    onClick={() => setActiveFilter('recent')}
                  >
                    Recent
                  </button>
                </div>
              )}
            </li>

            {!collapsed && (
              <li className="sidebarResultsStatus" role="status" aria-live="polite" aria-atomic="true">
                {visibleMenuItems.length} {visibleMenuItems.length === 1 ? 'module' : 'modules'} shown
              </li>
            )}

            {groupedMenuItems.map((section) => {
              const sectionIsCollapsed = !normalizedSearch && Boolean(collapsedSections[section.label]);

              return (
                <li className={`sidebarSection ${sectionIsCollapsed ? 'is-collapsed' : ''}`} key={section.label}>
                  {!collapsed && (
                    <button
                      type="button"
                      className="sidebarSectionHeading"
                      aria-expanded={!sectionIsCollapsed}
                      aria-controls={`sidebar-section-${section.label.replace(/\s+/g, '-').toLowerCase()}`}
                      title={`${sectionIsCollapsed ? 'Expand' : 'Collapse'} ${section.label}`}
                      onClick={() => toggleSection(section.label)}
                    >
                      <span className="sidebarSectionHeadingLabel">{section.label}</span>
                      <span className="sidebarSectionHeadingMeta">
                        <span className="sidebarSectionCount">{section.items.length}</span>
                        <ChevronRightRoundedIcon className="sidebarSectionChevron" />
                      </span>
                    </button>
                  )}
                  {(collapsed || !sectionIsCollapsed) && (
                    <ul
                      className="sidebarSectionList"
                      id={`sidebar-section-${section.label.replace(/\s+/g, '-').toLowerCase()}`}
                    >
                      {section.items.map(renderMenuItem)}
                    </ul>
                  )}
                </li>
              );
            })}

            {visibleMenuItems.length === 0 && !collapsed && (
              <li className="sidebarEmptyState">
                {activeFilter === 'recent' && !normalizedSearch ? <HistoryRoundedIcon /> : <SearchIcon />}
                <strong>{emptyStateTitle}</strong>
                <span>{emptyStateDescription}</span>
                {(normalizedSearch || activeFilter !== 'all') && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearch('');
                      setActiveFilter('all');
                    }}
                  >
                    {normalizedSearch ? 'Clear search' : 'Show all modules'}
                  </button>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </aside>
  )
}
